import './index.less'

const SJNoData = ({ text, onClick }: { text?: string; onClick?: () => void }) => {
  return (
    <div className="sc-no-data" onClick={onClick}>
      <img className="image" src={require('./no-data.png')} alt="" />
      <div className="tip-text">{text || '暂无数据'}</div>
    </div>
  )
}

export default SJNoData
